'use client';

import { useEffect } from 'react';
import { sendGTMEvent } from '@/common/util';

interface Props {
    missions: { id: number; name: string }[];
}

// GTM 埋點：任務中心頁載入時，把本次剛從未完成變已完成的任務各發一次 complete_tasks
// 只在 mount 時 fire 一次，避免 re-render（例如領取星塵後 MissionSection 重新排序）時重複觸發
export default function MissionCompletedTracker({ missions }: Props) {
    useEffect(() => {
        missions.forEach((m) =>
            sendGTMEvent({ event: 'complete_tasks', missionId: m.id, missionName: m.name })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
